import React from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import {Login} from './Login';
import Chat from './Chat';

export default function App (){

    return( 
    <Router>
        <Route path="/" exact component = {Login}/> 
        <Route path="/messages" component = {Chat}/>
    </Router>
    );
};
